import axios from "axios";
import React, { useEffect } from "react";
import { baseUrl } from "../../config/baseUrl";
import CollegeListTable from "./college-list-table";

export const CollegeView = () => {
  return <div>
    <CollegeListTable />
  </div>;
};
